import './hand-trigger.scss';
import React from "react"
import { HandTypeLabel } from "./HandTypeLabel";
import { HandTrigger, HandTypeOrderer } from '../../../../../../entities/rolls/HandTrigger';
import { MarkdownContainer } from '../../../../../theming/MarkdownContainer';

type Props = { handTrigger: HandTrigger }

export const HandTriggerComponent: React.FC<Props> = (props: Props) => {
    const { handTrigger } = props;
    let { handTypes, description } = handTrigger;
    handTypes = [...handTypes].sort(HandTypeOrderer)
    return (
        <div className="hand-trigger">
            <label>
                {handTypes.map(ht => <HandTypeLabel key={ht} handTypeName={ht} />)}
            </label>
            <MarkdownContainer>{description}</MarkdownContainer>
        </div>
    );
}